import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

const getBreakpointValue = (value: string): number => {
  const screens: Record<string, string> = fullConfig?.theme?.screens || {};
  if (((screens && Object.keys(screens).length) || 0) > 0) {
    return parseInt(screens[value].slice(0, screens[value].indexOf('px')));
  }
  return -1;
};

export const getCurrentBreakpoint = (): string => {
  let currentBreakpoint = '2xl';
  let biggestBreakpointValue = 999999;
  for (const breakpoint of Object.keys(fullConfig?.theme?.screens)) {
    const breakpointValue = getBreakpointValue(breakpoint);
    if (
      parseInt(breakpointValue?.toString() || '0') < biggestBreakpointValue &&
      window.innerWidth <= breakpointValue
    ) {
      biggestBreakpointValue = breakpointValue;
      currentBreakpoint = breakpoint;
    }
  }
  return currentBreakpoint;
};

export const isMobile = (): boolean => {
  return getCurrentBreakpoint() === 'sm';
};

export const LIGHT_THEME_CLASS_NAME = 'light-theme-ui';
export const DARK_THEME_CLASS_NAME = 'dark-theme-ui';

export const getActiveThemeClassName = (isDarkMode: boolean): string[] => {
  return isDarkMode ? [DARK_THEME_CLASS_NAME] : [LIGHT_THEME_CLASS_NAME];
};
